import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';

import DevicesMultiSelect from './DevicesMultiSelect';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    margin: '5px',
    height: '88vh',
  },
  textArea: {
    width: '100%',
    padding: '0 4px',
    resize: 'none'
  },
  center: {
    display: 'block',
    width: '70%',
    margin: '0 auto'
  },
  filterContainer: {
    padding: '8px 16px',
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: '#f5f5f5'
  }
});

export default function DevicesSelection(props, context) {
  const { devicesList, selectedDevices, handleSelection, onFilterChange, filterState } = props;
  const classes = useStyles();

  const textAreaRef = React.useRef();
  
  // Use filter state from parent or default to showing all
  const showEdge = filterState?.showEdge ?? true;
  const showUltra = filterState?.showUltra ?? true;

  // Clear the textarea when filter changes to avoid confusion
  React.useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.value = '';
    }
  }, [showEdge, showUltra]);


  // Since devicesList is already filtered by parent, just use it directly
  const filteredDevicesList = devicesList;

  function parseDevicesFilter() {
    const notFoundDevices = [];
    const devicesMap = {};
    const checkedDevicesList = [...selectedDevices];

    // Use filtered list instead of full list to respect the current filter
    filteredDevicesList.forEach((device, index) => devicesMap[device.DeviceID] = index);
    if (textAreaRef.current.value) {
      const devices = textAreaRef.current.value.split('\n');

      devices.forEach((device) => {
        if (devicesMap[device] !== undefined) {
          if (checkedDevicesList.indexOf(device) === -1) {
            /* only if exist in filtered device list and not exist in the new checked devices list */
            checkedDevicesList.push(device);
          }
        } else {
          notFoundDevices.push(device);
        }
      });

      handleSelection(checkedDevicesList);

      textAreaRef.current.value = notFoundDevices.join('\n');
    }
  }
  
  return (
    // <ClickAwayListener onClickAway={null/*() => setOpen(false)*/}>
    //   <div className={classes.root}>
        <Paper classes={{ root: classes.root }}>
          <Box className={classes.filterContainer}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showEdge}
                    onChange={(e) => onFilterChange && onFilterChange({ showEdge: e.target.checked, showUltra })}
                    color="primary"
                  />
                }
                label={context.t('edge_devices')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showUltra}
                    onChange={(e) => onFilterChange && onFilterChange({ showEdge, showUltra: e.target.checked })}
                    color="primary"
                  />
                }
                label={context.t('ultra_devices')}
              />
            </FormGroup>
          </Box>
          <DevicesMultiSelect
            key={`${showEdge}-${showUltra}-${filteredDevicesList.length}`}
            items={filteredDevicesList}
            selectedItems={selectedDevices}
            workingMode={'config'}
            handleSelection={handleSelection}
          />
          <TextareaAutosize
            className={classes.textArea}
            maxRows={6}
            minRows={6}
            // rowsMin={6}
            // rowsMax={6}
            placeholder={context.t('copy_device_id_from_excel')}
            ref={textAreaRef}
          />
          <Button
            classes={{ root: classes.center }}
            variant='contained'
            color='primary'
            onClick={parseDevicesFilter}
          >{context.t('check_devices')}</Button>
        </Paper>
    //   </div>
    // </ClickAwayListener>
  );
}

DevicesSelection.propTypes = {
  devicesList: PropTypes.array,
  handleSelection: PropTypes.func,
  selectedDevices: PropTypes.array,
  onFilterChange: PropTypes.func,
  filterState: PropTypes.shape({
    showEdge: PropTypes.bool,
    showUltra: PropTypes.bool,
  }),
};

DevicesSelection.contextTypes = {
  t: PropTypes.func.isRequired
};
